import { Reservations } from '@lib/state';

export type BulkChangeBillingRun = Reservations.BulkChangeBillingRunModel;
export type BulkChangeBillingRunDetail = Reservations.BulkChangeBillingRunDetailModel;
export type BulkChangeBillingStatus = Reservations.BulkChangeBillingStatusModel;
export type BulkChangeBillingPreview = Reservations.BulkChangeBillingPreviewModel;

export type BulkChangeBillingRunStatus = Reservations.BulkChangeBillingRunStatus;
export const BulkChangeBillingRunStatus = Reservations.BulkChangeBillingRunStatus;

export type BulkChangeBillingItemStatus = Reservations.BulkChangeBillingItemStatus;
export const BulkChangeBillingItemStatus = Reservations.BulkChangeBillingItemStatus;

export type BulkChangeBillingRequest = Reservations.BulkChangeBillingRequest;
export type BulkChangeBillingPreviewRequest = Reservations.BulkChangeBillingPreviewRequest;

export type GetBulkChangeBillingRunsRequest = {
  propertyId?: string;
  corporateAccountId?: string;
  status?: BulkChangeBillingRunStatus;
  recordNumber?: number;
  roomTypeId?: string;
};
